// تحويل اللون الرئيسي إلى درجات مختلفة
function generateColorPalette(hexColor) {
  // تحويل اللون إلى RGB
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  // إنشاء درجات مختلفة من اللون
  return {
    50: adjustBrightness(r, g, b, 0.95),
    100: adjustBrightness(r, g, b, 0.9),
    200: adjustBrightness(r, g, b, 0.75),
    300: adjustBrightness(r, g, b, 0.6),
    400: adjustBrightness(r, g, b, 0.45),
    500: hexColor,
    600: adjustBrightness(r, g, b, -0.15),
    700: adjustBrightness(r, g, b, -0.3),
    800: adjustBrightness(r, g, b, -0.45),
    900: adjustBrightness(r, g, b, -0.6),
  };
}

// تعديل سطوع اللون
function adjustBrightness(r, g, b, percent) {
  const t = percent < 0 ? 0 : 255;
  const p = percent < 0 ? -percent : percent;

  r = Math.round((t - r) * p + r);
  g = Math.round((t - g) * p + g);
  b = Math.round((t - b) * p + b);

  return `#${(0x1000000 + (r * 0x10000) + (g * 0x100) + b).toString(16).slice(1)}`;
}

// تطبيق الثيم على المستند
export function applyTheme(settings) {
  const root = document.documentElement;

  // تطبيق الوضع الداكن/الفاتح
  if (settings.theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }

  // تطبيق اتجاه النص
  root.setAttribute('dir', settings.direction);

  // تطبيق الخط
  root.className = root.className
    .replace(/font-(cairo|tajawal|ibm-plex-sans-arabic)/g, '')
    .trim();
  root.classList.add(`font-${settings.font}`);

  // تطبيق حجم الخط
  root.style.fontSize = settings.fontSize === 'small' ? '14px' : 
                       settings.fontSize === 'large' ? '18px' : '16px';

  // تطبيق نصف قطر الحواف
  root.style.setProperty('--border-radius', 
    settings.borderRadius === 'none' ? '0' :
    settings.borderRadius === 'small' ? '0.25rem' :
    settings.borderRadius === 'large' ? '1rem' : '0.5rem'
  );

  // توليد وتطبيق درجات اللون الرئيسي
  const palette = generateColorPalette(settings.primaryColor);
  Object.entries(palette).forEach(([shade, color]) => {
    root.style.setProperty(`--color-primary-${shade}`, color);
  });

  // تطبيق CSS مخصص
  let styleElement = document.getElementById('custom-styles');
  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.id = 'custom-styles';
    document.head.appendChild(styleElement);
  }
  styleElement.textContent = settings.customCSS || '';
}

// حفظ الإعدادات في التخزين المحلي
export function saveThemeSettings(settings) {
  localStorage.setItem('themeSettings', JSON.stringify(settings));
}

// استرجاع الإعدادات من التخزين المحلي
export function loadThemeSettings() {
  const saved = localStorage.getItem('themeSettings');
  return saved ? JSON.parse(saved) : null;
}

// تطبيق الإعدادات الافتراضية
export function applyDefaultTheme() {
  const defaultSettings = {
    theme: 'light',
    primaryColor: '#4F46E5',
    direction: 'rtl',
    font: 'cairo',
    fontSize: 'medium',
    borderRadius: 'medium',
    customCSS: ''
  };
  
  applyTheme(defaultSettings);
  return defaultSettings;
}
